// extracted by mini-css-extract-plugin
export default {"pageWrap":"Helper_pageWrap__mAsyx"};